import GaEvent from './GaEvent';

export default class MemberReviewAddedGaEvent extends GaEvent {
  constructor() {
    super('member_review_added');
  }
}
